module.exports = __webpack_public_path__ + "img/CASAA.a5e7b3c9.png";